import { ContentContainer } from "@Components/forecast/ContentContainer";
import { Button } from "@Components/shared/Button";
import { useTranslations } from "@Context/TranslationContext/TranslationContext";
import ErrorIcon from "@Resources/images/iconsets/error-icon.svg?react";

export const Error = () => {
  const { t } = useTranslations();

  return (
    <ContentContainer>
      <div className="m:flex m:flex-col m:items-center m:justify-center m:px-4 m:py-8 m:tracking-0.2 m:text-neutral-white m:antialiased">
        <div className="m:mb-2">
          <ErrorIcon width="48" height="48" />
        </div>

        <h2 className="m:text-center m:text-3xl m:leading-tight m:font-medium m:tracking-0.2">
          {t("forecast.error.title")}
        </h2>

        <p className="m:pt-1 m:pb-5 m:text-center m:text-xl m:leading-normal m:font-normal m:tracking-0.4">
          {t("forecast.error.message")}
        </p>

        <Button onClick={() => window.location.reload()}>
          {t("forecast.error.errorMessageRefresh")}
        </Button>
      </div>
    </ContentContainer>
  );
};
